import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { BookOpen } from "lucide-react";
import Filter from "./UserRoleFilter";
// import Pagination from "./UserRolePagination";
import Pagination from "../../../components/common/Pagination";
import RowAction from "./UserRoleRowAction";
import AssignDrawer from "./UserRoleAssignDrawer";
import { getUserRoles } from "../../../api/settings/user_roles";
import { showErrorToast } from "../../../components/ConfirmDialog";

const UserRoleListPage = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filters, setFilters] = useState({ keyword: "", role_id: "" });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // ✅ Bọc fetchData trong useCallback để tránh cảnh báo useEffect deps
  const fetchData = useCallback(async () => {
    try {
      const res = await getUserRoles({ page, pageSize, ...filters });
      setData(res?.data || []);
      setTotal(res?.total || 0);
    } catch (err) {
      console.error(err);
      showErrorToast("Không thể tải danh sách phân quyền");
    }
  }, [page, pageSize, filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const openGuide = () => {
    window.open(
      `${window.location.origin}/guides/settings-user-roles-guide.html`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div>
      <div className="flex flex-col gap-3 mb-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Gán quyền nhân viên</h1>
          <p className="text-sm text-gray-500 mt-1">
            Chọn chi nhánh → nhân viên → quyền sử dụng theo bộ phận của chi nhánh đó.
          </p>
        </div>
        <button
          onClick={openGuide}
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl border border-red-200 bg-white text-red-700 hover:bg-red-50 transition-all text-xs font-black uppercase tracking-widest"
        >
          <BookOpen size={16} />
          Hướng dẫn sử dụng
        </button>
      </div>

      <Filter
        onNewClick={() => {
          setSelected(null);
          setDrawerOpen(true);
        }}
        onFilterChange={(f) => {
          setFilters(f);
          setPage(1);
        }}
      />

      {/* <div className="border rounded-md overflow-x-auto">
        <table className="w-full text-sm bg-white">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-3 py-2">Mã NV</th>
              <th className="px-3 py-2">Họ tên</th>
              <th className="px-3 py-2">Phòng ban</th>
              <th className="px-3 py-2">Quyền</th>
              <th className="px-3 py-2">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-4 text-gray-500">
                  Không có dữ liệu.
                </td>
              </tr>
            ) : (
              data.map((u) => (
                <tr
                  key={u.composite_id || `${u.employee_id}-${u.role_id}`}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="px-3 py-2 text-center">{u.employee_code}</td>
                  <td className="px-3 py-2">{u.full_name}</td>
                  <td className="px-3 py-2">{u.department_name}</td>
                  <td className="px-3 py-2">{u.role_name}</td>
                  <td className="px-3 py-2">
                    <RowAction
                      data={u}
                      onEdit={() => {
                        setSelected(u);
                        setDrawerOpen(true);
                      }}
                      onDeleted={fetchData}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div> */}


<div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
  <div className="overflow-x-auto">
    <table className="w-full text-left border-collapse">
      {/* Header với phong cách Black/Uppercase đặc trưng */}
      <thead className="bg-gray-50/50 border-b border-gray-100">
        <tr>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest w-20 text-center">STT</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest w-32">Mã NV</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Họ và Tên</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Phòng ban</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Vai trò / Quyền</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest">Override data scope</th>
          <th className="p-5 text-[11px] font-black text-gray-400 uppercase tracking-widest text-center">Thao tác</th>
        </tr>
      </thead>

      <tbody className="divide-y divide-gray-50">
        {data.length === 0 ? (
          <tr>
            <td colSpan={7} className="p-20 text-center">
              <div className="flex flex-col items-center gap-3">
                <div className="w-16 h-16 rounded-3xl bg-gray-50 flex items-center justify-center border-2 border-dashed border-gray-200 text-gray-300">
                   <FontAwesomeIcon icon={faUserSlash} size="lg" />
                </div>
                <p className="text-gray-400 font-black italic uppercase text-xs tracking-widest">
                  Không tìm thấy dữ liệu nhân viên
                </p>
              </div>
            </td>
          </tr>
        ) : (
          data.map((u, index) => (
            <tr 
              key={u.composite_id || `${u.employee_id}-${u.role_id}`} 
              className="hover:bg-red-50/30 transition-colors group"
            >
              {/* STT */}
              <td className="p-5 text-center">
                <span className="text-xs font-bold text-gray-400">
                  {index + 1}
                </span>
              </td>

              {/* Mã NV: Badge Tech Style */}
              <td className="p-5">
                <span className="px-3 py-1 bg-slate-100 text-slate-600 rounded-lg text-[10px] font-black uppercase tracking-tighter border border-slate-200 font-mono">
                  {u.employee_code}
                </span>
              </td>

              {/* Họ tên: Font Black & Avatar Initials */}
              <td className="p-5">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-red-50 text-red-600 flex items-center justify-center text-[10px] font-black border border-red-100">
                    {u.full_name?.split(' ').pop()?.charAt(0)}
                  </div>
                  <p className="font-black text-gray-800 text-sm group-hover:text-red-700 transition-colors">
                    {u.full_name}
                  </p>
                </div>
              </td>

              {/* Phòng ban */}
              <td className="p-5">
                <p className="text-sm font-bold text-gray-600">
                  {u.department_name || "—"}
                </p>
                {u.branch_name && (
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">
                    {u.branch_name}
                  </p>
                )}
              </td>

              {/* Vai trò: Colored Badge */}
              <td className="p-5">
                <span className={`px-3 py-1 rounded-xl text-[10px] font-black uppercase tracking-widest shadow-sm border ${
                  (u.usage_role_label || u.role_name)?.toLowerCase().includes('admin') 
                  ? 'bg-red-50 text-red-600 border-red-100' 
                  : 'bg-white text-gray-500 border-gray-200'
                }`}>
                  {u.usage_role_label || u.role_name}
                </span>
              </td>

              <td className="p-5">
                {u.override_modules ? (
                  <div className="flex flex-wrap gap-2">
                    {u.override_modules.split(", ").map((moduleCode) => (
                      <span
                        key={moduleCode}
                        className="px-2.5 py-1 rounded-lg bg-blue-50 text-blue-700 border border-blue-100 text-[10px] font-black uppercase tracking-widest"
                      >
                        {moduleCode}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className="text-xs italic text-gray-400">Mặc định theo vai trò</span>
                )}
              </td>

              {/* Thao tác */}
              <td className="p-5">
                <div className="flex justify-center items-center">
                  <RowAction
                    data={u}
                    onEdit={() => {
                      setSelected({
                        employee_id: u.employee_id,
                        role_id: u.role_id,
                        branch_id: u.branch_id,
                        department_id: u.department_id,
                        usage_role_id: u.usage_role_id,
                      });
                      setDrawerOpen(true);
                    }}
                    onDeleted={fetchData}
                  />
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
</div>


      <Pagination
        totalRecords={total}
        currentPage={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />

      <AssignDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        data={selected}
        onSaved={() => {
          setDrawerOpen(false);
          fetchData();
        }}
      />
    </div>
  );
};

export default UserRoleListPage;
